<template>
  <el-dialog
    class="dialog-inner-scroller max-h-[469px]"
    :model-value="visible"
    align-center
    :before-close="() => {
      emit('close')
    }"
    width="480"
  >
    <template #header>
      <h4>
        来账银行账户
      </h4>
    </template>

    <el-skeleton v-if="loading" class="mt-3" active height="20px" />
    <el-table v-else class="normal-table" :border="true" :scrollbar-always-on="true" :data="props.bankList">
      <el-table-column align="center" prop="bankName" label="银行名称" :min-width="215" show-overflow-tooltip />
      <el-table-column align="center" prop="bankAccount" label="来账银行卡号" :min-width="209" />
    </el-table>

    <template #footer>
      <div class="flex justify-center">
        <el-button type="primary" @click="emit('close')">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';

const emit = defineEmits(['close']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  bankList: {
    type: Array as PropType<{ bankName: string; bankAccount: string }[]>,
    default: () => [],
  },
});

const loading = ref(false);

</script>
